import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { useHeaderButtonContext } from "@/components/Navigation/Buttons/HeaderButton/context/headerButton.context";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Icon = ({ className, children }: Props) => {
    const { iconPrefix, icon } = useHeaderButtonContext();

    return (
        <i
            className={cn(
                "tw:relative tw:text-3xl! tw:mr-1 tw:mb-1 tw:align-middle",
                `${iconPrefix} la-${icon}`,
                className
            )}
        >
            {children}
        </i>
    );
};
